import { IJsonQueryHighway } from '../../../packages/api-models/common/json_query';
import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function addHighwaysInJsonQuery(jsonQuery: TJsonQuery, highwayIds: number[]): TGeoValue[] {
  const geoValue = getGeoValue()(jsonQuery);

  let value: TGeoValue[] = [];

  if (geoValue) {
    value = geoValue.filter(({ type }) => type !== 'highway');
  }

  return value.concat(highwayIds.map(id => ({ id, type: 'highway' }) as IJsonQueryHighway));
}
